//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false
}
